<section *ngIf="appState.isWalletConnected()" class="max-w-[1320px] mx-auto px-6 lg:px-10 pt-6 pb-12 relative z-10 animate-fade-in">
  
  <!-- Header -->
  <div class="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
    <div>
      <h1 class="font-display font-black text-[32px] md:text-[40px] text-white tracking-wide mb-1">Portfolio</h1>
      <p class="text-text-muted text-[13px]">Track your assets, positions and performance across DeFi.</p>
    </div>
    <div class="flex items-center text-text-muted text-[11px] gap-2 font-bold mb-2">
      <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path></svg>
      <span>Last updated: 1 min ago</span>
      <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path></svg>
    </div>
  </div>

  <!-- Overview Cards -->
  <div class="mb-6">
    <h3 class="text-white font-bold text-[15px] mb-4">Overview</h3>
    <div class="flex flex-wrap lg:flex-nowrap gap-4">
      
      <!-- Card 1: Portfolio Value -->
      <div class="bg-[#050505] border border-white/5 p-6 rounded-[16px] flex-grow min-w-[280px] relative overflow-hidden group hover:border-white/10 transition-colors">
        <div class="flex items-center gap-1.5 text-text-muted text-[11.5px] font-bold mb-3">Total Portfolio Value <svg class="w-3 h-3 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></div>
        <div class="font-display font-black text-[32px] text-white mb-2 tracking-tight">${{overviewMetrics().totalValue | number:'1.2-4'}}</div>
        <div class="flex items-center gap-2 text-[11.5px] font-bold">
          <span class="text-text-muted">Live sync</span>
        </div>
        <!-- Abstract sparkline -->
        <svg class="absolute right-0 bottom-3 text-gold w-36 h-14 opacity-70 group-hover:opacity-100 transition-opacity" viewBox="0 0 100 40" fill="none" preserveAspectRatio="none">
          <path d="M0 35 Q10 25 20 30 T40 15 T60 20 T80 5 T100 10" stroke="currentColor" stroke-width="1.5" />
          <path d="M0 35 Q10 25 20 30 T40 15 T60 20 T80 5 T100 10 L100 40 L0 40 Z" fill="url(#grad)" opacity="0.1" />
          <defs>
            <linearGradient id="grad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="currentColor" />
              <stop offset="100%" stop-color="transparent" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <!-- Card 2: Total Invested -->
      <div class="bg-[#050505] border border-white/5 p-6 rounded-[16px] flex-grow min-w-[200px] hover:border-white/10 transition-colors">
        <div class="flex items-center gap-1.5 text-text-muted text-[11.5px] font-bold mb-3">Total Invested</div>
        <div class="font-display font-black text-[24px] text-white tracking-tight">${{overviewMetrics().invested | number:'1.2-4'}}</div>
      </div>

      <!-- Card 3: Total Earnings -->
      <div class="bg-[#050505] border border-white/5 p-6 rounded-[16px] flex-grow min-w-[200px] hover:border-white/10 transition-colors">
        <div class="flex items-center gap-1.5 text-text-muted text-[11.5px] font-bold mb-3">Total Earnings <svg class="w-3 h-3 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></div>
        <div class="font-display font-black text-[24px] text-white tracking-tight mb-2">${{overviewMetrics().earnings | number:'1.2-4'}}</div>
        <div class="text-text-dim text-[11.5px] font-bold">Unrealized</div>
      </div>
      
      <!-- Card 4: Assets -->
      <div class="bg-[#050505] border border-white/5 p-5 rounded-[16px] flex-grow min-w-[140px] flex flex-col justify-center hover:border-white/10 transition-colors">
        <div class="text-text-muted text-[11.5px] font-bold mb-2">Assets</div>
        <div class="text-white font-black text-[22px] tracking-tight leading-none mb-1">{{overviewMetrics().assetsCount}}</div>
        <div class="text-text-dim text-[11px] font-bold">Tokens</div>
      </div>

      <!-- Card 5: Positions -->
      <div class="bg-[#050505] border border-white/5 p-5 rounded-[16px] flex-grow min-w-[150px] flex flex-col justify-center hover:border-white/10 transition-colors">
        <div class="text-text-muted text-[11.5px] font-bold mb-2">Active Positions</div>
        <div class="text-white font-black text-[22px] tracking-tight leading-none mb-1">{{overviewMetrics().positionsCount}}</div>
        <div class="text-text-dim text-[11px] font-bold">Across protocols</div>
      </div>

    </div>
  </div>

  <!-- Charts -->
  <div class="flex flex-col lg:flex-row gap-6 mb-12">
    <!-- Line Chart -->
    <div class="bg-[#0c0c0c]/80 border border-white/5 rounded-[20px] p-6 lg:flex-[2_2_0%] relative">
       <div class="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4">
         <h3 class="text-white font-bold text-[15px]">Portfolio Performance</h3>
         <div class="flex border border-white/[0.08] rounded-[8px] p-0.5 bg-white/[0.02]">
           <button *ngFor="let tf of timeframes" (click)="setTimeframe(tf)"
              [class.bg-white_10]="activeTimeframe === tf"
              [class.text-white]="activeTimeframe === tf"
              [class.shadow-sm]="activeTimeframe === tf"
              [class.text-text-muted]="activeTimeframe !== tf"
              class="px-3.5 py-1.5 text-[11px] font-bold rounded-[6px] transition-all hover:text-white"
              [ngClass]="activeTimeframe === tf ? 'bg-white/10 text-white' : 'text-text-muted'">
             {{tf}}
           </button>
         </div>
       </div>
       
       <div class="relative w-full h-[240px]">
          <div #performanceChart class="absolute inset-0"></div>
          
          <!-- Dynamic Chart Tooltip/Highlight for visual accuracy to design -->
          <div class="absolute top-[20%] left-[45%] bg-[#1a1a1a] border border-white/10 px-3 py-2 rounded-lg pointer-events-none shadow-lg" *ngIf="activeTimeframe === '30D'">
             <div class="text-[10px] text-text-muted text-center mb-1 font-bold">Today</div>
             <div class="text-white font-black text-[14px]">${{overviewMetrics().totalValue | number:'1.2-4'}}</div>
          </div>
       </div>
    </div>

    <!-- Doughnut Chart -->
    <div class="bg-[#0c0c0c]/80 border border-white/5 rounded-[20px] p-6 lg:flex-[1_1_0%]">
       <h3 class="text-white font-bold text-[15px] mb-6">Allocation</h3>
       <div class="flex flex-col sm:flex-row items-center justify-center gap-8 h-full min-h-[220px]">
         <!-- Chart -->
         <div class="relative w-[150px] h-[150px] shrink-0">
            <div #allocationChart class="absolute inset-0"></div>
            <div class="absolute inset-0 flex flex-col items-center justify-center pointer-events-none pt-1">
               <div class="text-white font-black text-[15px] tracking-tight">${{overviewMetrics().totalValue | number:'1.2-4'}}</div>
               <div class="text-text-muted text-[10px] font-bold mt-0.5">Total</div>
            </div>
         </div>
         <!-- Legend -->
         <div class="flex flex-col gap-3.5 w-full sm:w-auto flex-1 max-w-[200px]">
            <div *ngFor="let al of dynamicAllocations()" class="flex items-center justify-between text-xs w-full">
               <div class="flex items-center gap-2">
                 <span class="w-2.5 h-2.5 rounded-full" [style.backgroundColor]="al.color"></span>
                 <span class="text-text-muted font-bold">{{al.name}}</span>
               </div>
               <div class="flex items-center gap-3">
                 <span class="text-white font-black">${{al.value | number:'1.2-4'}}</span>
                 <span class="text-text-dim text-[10.5px] w-[35px] text-right font-bold">{{al.percent}}%</span>
               </div>
            </div>
         </div>
       </div>
    </div>
  </div>

  <!-- Tabs & Table -->
  <div class="mb-12">
    <div class="flex flex-col md:flex-row md:items-center justify-between border-b border-white/5 pb-0 mb-6 gap-4">
      <div class="flex items-center gap-7 px-2">
        <button *ngFor="let tab of tabs" (click)="setTab(tab)"
          [class.text-gold]="activeTab === tab"
          [class.border-gold]="activeTab === tab"
          [class.text-text-muted]="activeTab !== tab"
          [class.border-transparent]="activeTab !== tab"
          class="pb-4 text-[13.5px] font-bold border-b-2 hover:text-white transition-colors relative top-[1px]">
          {{tab}}
        </button>
      </div>
      <div class="flex items-center gap-5 pb-3 px-2">
        <label class="flex items-center gap-2 cursor-pointer group">

          <label class="relative inline-flex items-center cursor-pointer">
            <input type="checkbox" [ngModel]="hideZeroBalances()" (ngModelChange)="hideZeroBalances.set($event)" class="sr-only peer">
            <div
              class="w-8 h-4 sm:w-11 sm:h-6 bg-[#1a1a1a] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-[#888] peer-checked:after:bg-gold after:border-gray-300 after:border after:rounded-full after:h-3.5 after:w-3.5 sm:after:h-5 sm:after:w-5 after:transition-all peer-checked:bg-gold/20 border border-white/10">
            </div>
          </label>
          <span class="text-text-muted text-[12px] font-bold group-hover:text-white transition-colors">Hide Zero Balance</span>
        </label>
      </div>
    </div>

    <!-- Table -->
    <div *ngIf="activeTab === 'Assets'">
      
      <!-- Desktop Table View -->
      <div *ngIf="!appState.isBalancesLoading()" class="hidden md:block overflow-x-auto bg-[#0c0c0c]/30 rounded-2xl border border-white/5">
        <table class="w-full min-w-[900px]">
          <thead>
            <tr class="text-text-dim text-[10.5px] font-bold uppercase tracking-wider text-left border-b border-white/5">
              <th class="py-4 px-6 flex items-center gap-1">Asset <svg class="w-3 h-3 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></th>
              <th class="py-4 px-4">Balance <svg class="w-2.5 h-2.5 inline-block ml-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path></svg></th>
              <th class="py-4 px-4">Price</th>
              <th class="py-4 px-4">Value</th>
              <th class="py-4 px-4">Change (24h)</th>
              <th class="py-4 px-4">Allocation</th>
              <th class="py-4 px-6 text-right"></th>
            </tr>
          </thead>
          <tbody class="text-sm">
            <tr *ngFor="let asset of paginatedAssets(); trackBy: trackByAsset" class="border-b border-white/5 hover:bg-white/[0.02] transition-colors group">
              <td class="py-4 px-6">
                <div class="flex items-center gap-3">
                  <img *ngIf="asset.iconUrl" [src]="asset.iconUrl" class="w-8 h-8 rounded-full object-cover border border-white/10" />
                  <div *ngIf="!asset.iconUrl" class="w-8 h-8 rounded-full flex items-center justify-center font-black text-white text-[11px]" [style.backgroundColor]="asset.color">{{asset.symbol.charAt(0)}}</div>
                  <div>
                    <div class="text-white font-black text-[13px]">{{asset.symbol}}</div>
                    <div class="text-text-muted text-[11px] font-bold">{{asset.name}}</div>
                  </div>
                </div>
              </td>
              <td class="py-4 px-4">
                <div class="text-white font-black text-[13px]">{{ appState.getFormattedBalance(asset.address) }} <span class="text-text-muted ml-0.5">{{asset.symbol}}</span></div>
              </td>
              <td class="py-4 px-4">
                <div class="text-white font-bold text-[13px]">${{asset.price | number:'1.2-4'}}</div>
                <div [ngClass]="asset.priceChange >= 0 ? 'text-emerald-400' : 'text-red-400'" class="text-[11px] font-bold">{{asset.priceChange > 0 ? '+' : ''}}{{asset.priceChange | number:'1.2-4'}}%</div>
              </td>
              <td class="py-4 px-4 font-black text-white text-[13.5px]">${{asset.value | number:'1.2-4'}}</td>
              <td class="py-4 px-4">
                <span [ngClass]="asset.priceChange >= 0 ? 'text-emerald-400' : 'text-red-400'" class="font-bold text-[12px]">{{asset.priceChange > 0 ? '+' : ''}}{{asset.priceChange | number:'1.2-4'}}%</span>
              </td>
              <td class="py-4 px-4">
                <div class="flex items-center gap-3 w-full max-w-[140px]">
                  <span class="text-white text-[11.5px] font-bold w-10">{{asset.allocation}}%</span>
                  <div class="flex-1 h-[4px] bg-white/[0.08] rounded-full overflow-hidden">
                    <div class="h-full bg-gold rounded-full" [style.width]="asset.allocation + '%'"></div>
                  </div>
                </div>
              </td>
              <td class="py-4 px-6 text-right flex justify-end gap-2">
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile Card View -->
      <div *ngIf="!appState.isBalancesLoading()" class="md:hidden flex flex-col gap-4">
        <div *ngFor="let asset of paginatedAssets(); trackBy: trackByAsset" class="bg-[#0c0c0c]/30 border border-white/5 rounded-2xl p-5 hover:border-white/10 transition-colors">
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center gap-3">
              <img *ngIf="asset.iconUrl" [src]="asset.iconUrl" class="w-10 h-10 rounded-full object-cover border border-white/10" />
              <div *ngIf="!asset.iconUrl" class="w-10 h-10 rounded-full flex items-center justify-center font-black text-white text-[13px]" [style.backgroundColor]="asset.color">{{asset.symbol.charAt(0)}}</div>
              <div>
                <div class="text-white font-black text-[15px]">{{asset.symbol}}</div>
                <div class="text-text-muted text-[12px] font-bold">{{asset.name}}</div>
              </div>
            </div>
            <div class="text-right">
              <div class="text-white font-black text-[15px]">${{asset.value | number:'1.2-4'}}</div>
              <div [ngClass]="asset.priceChange >= 0 ? 'text-emerald-400' : 'text-red-400'" class="text-[12px] font-bold">{{asset.priceChange > 0 ? '+' : ''}}{{asset.priceChange | number:'1.2-4'}}%</div>
            </div>
          </div>
          
          <div class="flex flex-col gap-3">
            <div class="flex items-center justify-between pt-3 border-t border-white/5">
              <span class="text-text-muted text-[12px] font-bold">Balance</span>
              <span class="text-white font-black text-[13px]">{{ appState.getFormattedBalance(asset.address) }} {{asset.symbol}}</span>
            </div>
            <div class="flex items-center justify-between">
              <span class="text-text-muted text-[12px] font-bold">Price</span>
              <span class="text-white font-bold text-[13px]">${{asset.price | number:'1.2-4'}}</span>
            </div>
            <div class="flex items-center justify-between">
              <span class="text-text-muted text-[12px] font-bold">Allocation</span>
              <div class="flex items-center gap-3 w-[120px]">
                <span class="text-white text-[12px] font-bold">{{asset.allocation}}%</span>
                <div class="flex-1 h-[4px] bg-white/[0.08] rounded-full overflow-hidden">
                  <div class="h-full bg-gold rounded-full" [style.width]="asset.allocation + '%'"></div>
                </div>
              </div>
            </div>
            <div class="flex items-center justify-end gap-2 pt-3 border-t border-white/5">
            </div>
          </div>
        </div>
      </div>
      
      <!-- Pagination Controls -->
      <div *ngIf="!appState.isBalancesLoading() && totalPages() > 1" class="flex justify-center items-center gap-4 mt-6">
        <button (click)="prevPage()" [disabled]="currentPage === 1" class="p-2 rounded-lg bg-white/5 hover:bg-white/10 disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-white">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
        </button>
        <span class="text-text-dim text-sm font-bold">Page {{ currentPage }} of {{ totalPages() }}</span>
        <button (click)="nextPage()" [disabled]="currentPage === totalPages()" class="p-2 rounded-lg bg-white/5 hover:bg-white/10 disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-white">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
        </button>
      </div>


      <!-- Loading State (Assets) -->
      <div *ngIf="appState.isBalancesLoading()" class="flex flex-col gap-4 mt-4">
        <div *ngFor="let _ of [1,2,3,4,5]" class="bg-white/[0.02] border border-white/10 rounded-2xl p-4 flex items-center justify-between">
          <div class="flex items-center gap-4">
            <div class="w-10 h-10 rounded-full bg-white/[0.05] animate-pulse"></div>
            <div class="flex flex-col gap-2">
              <div class="w-24 h-4 bg-white/[0.05] rounded animate-pulse"></div>
              <div class="w-16 h-3 bg-white/[0.03] rounded animate-pulse"></div>
            </div>
          </div>
          <div class="flex flex-col items-end gap-2">
            <div class="w-20 h-4 bg-white/[0.05] rounded animate-pulse"></div>
            <div class="w-12 h-3 bg-white/[0.03] rounded animate-pulse"></div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!appState.isBalancesLoading() && filteredAssets().length === 0" class="text-center py-12 bg-[#0c0c0c]/30 rounded-2xl border border-white/5 mt-4">
        <p class="text-text-muted text-[13px] font-bold">No assets found.</p>
        <p class="text-text-dim text-[11px] mt-1" *ngIf="!appState.isWalletConnected()">Please connect your wallet to view your balances.</p>
      </div>

    </div>
  </div>

  <!-- Your Positions -->
  <div *ngIf="activeTab === 'Positions'">
    <div class="flex items-center justify-between mb-5 px-1">
      <h3 class="text-white font-bold text-[18px]">Your Positions</h3>
      <button [routerLink]="['/liquidity']" class="text-gold text-[12px] font-bold flex items-center gap-1.5 hover:underline">View all <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3"/></svg></button>
    </div>
    
    <!-- Loading State -->
    <div *ngIf="isLoadingPositions" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <div *ngFor="let _ of [1,2,3,4]" class="bg-[#050505] border border-white/[0.08] rounded-[16px] p-5 animate-pulse">
         <div class="flex items-center justify-between mb-6">
           <div class="flex items-center gap-2.5">
             <div class="flex -space-x-1.5">
                <div class="w-6 h-6 rounded-full bg-white/10"></div>
                <div class="w-6 h-6 rounded-full bg-white/10"></div>
             </div>
             <div class="w-20 h-4 bg-white/10 rounded-full"></div>
           </div>
           <div class="w-12 h-4 bg-white/10 rounded-full"></div>
         </div>
         <div class="space-y-4 mb-6">
           <div class="flex items-center justify-between">
             <div class="w-16 h-3 bg-white/10 rounded-full"></div>
             <div class="w-20 h-3 bg-white/10 rounded-full"></div>
           </div>
           <div class="flex items-center justify-between">
             <div class="w-16 h-3 bg-white/10 rounded-full"></div>
             <div class="w-20 h-3 bg-white/10 rounded-full"></div>
           </div>
         </div>
         <div class="grid grid-cols-2 gap-2 mt-2">
           <div class="w-full h-10 bg-white/10 rounded-[10px]"></div>
           <div class="w-full h-10 bg-white/10 rounded-[10px]"></div>
         </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoadingPositions && positions().length === 0" class="py-12 text-center border border-white/5 rounded-[16px] bg-[#050505]/50">
      <div class="w-16 h-16 bg-white/[0.02] border border-white/5 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg class="w-8 h-8 text-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      </div>
      <h4 class="text-white font-bold text-[16px] mb-2">No Active Positions</h4>
      <p class="text-text-muted text-[13px] mb-6 max-w-sm mx-auto">You don't have any active liquidity or farming positions. Add liquidity to start earning fees.</p>
      <button [routerLink]="['/liquidity/new']" class="bg-gold/10 text-gold border border-gold/20 hover:bg-gold hover:text-[#050505] transition-colors font-bold text-[13px] px-6 py-2.5 rounded-[8px]">
        Add Liquidity
      </button>
    </div>

    <!-- Active Positions -->
    <div *ngIf="!isLoadingPositions && positions().length > 0">
      <div class="flex flex-col gap-4 mb-6">
        <div *ngFor="let pos of paginatedPositions()" class="bg-[#0c0c0c] border border-white/10 rounded-[20px] hover:border-gold/40 hover:shadow-[0_0_20px_rgba(245,183,59,0.1)] transition-all duration-300 group">
          <div class="p-4 sm:p-6 flex flex-col gap-6">
            
            <!-- Top Row: Token Info & Chart -->
            <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-6">
              <!-- Left: Token Info -->
              <div class="flex items-center gap-4">
                <div class="flex -space-x-3">
                  <div class="w-12 h-12 rounded-full flex items-center justify-center text-[12px] font-black text-white border-[3px] border-[#0c0c0c] z-10 shadow-lg overflow-hidden transition-transform group-hover:scale-105" [style.backgroundColor]="pos.color1">
                     <img *ngIf="pos.image1" [src]="pos.image1" class="w-full h-full object-cover">
                     <span *ngIf="!pos.image1">{{pos.icon1?.charAt(0)}}</span>
                  </div>
                  <div *ngIf="pos.icon2" class="w-12 h-12 rounded-full flex items-center justify-center text-[12px] font-black text-white border-[3px] border-[#0c0c0c] shadow-lg overflow-hidden transition-transform group-hover:scale-105" [style.backgroundColor]="pos.color2">
                     <img *ngIf="pos.image2" [src]="pos.image2" class="w-full h-full object-cover">
                     <span *ngIf="!pos.image2">{{pos.icon2?.charAt(0)}}</span>
                  </div>
                </div>
                <div>
                  <div class="flex items-center gap-2 mb-1.5">
                    <span class="text-white font-black text-[20px] tracking-tight">{{pos.title}}</span>
                  </div>
                  <div class="flex items-center gap-3 text-[13px] font-bold text-text-muted">
                     <span *ngIf="pos.isStakedInFarm" class="text-gold flex items-center gap-1"><svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg> Staked</span>
                     <span *ngIf="!pos.isStakedInFarm">{{pos.type}}</span>
                     <span class="text-white/20">•</span>
                     <span>ID: #{{ pos.tokenId || pos._id?.substring(pos._id.length - 6) || '---' }}</span>
                  </div>
                </div>
              </div>

              <!-- Right: Sparkline Chart -->
              <div class="flex-shrink-0 flex sm:justify-end">
                 <app-sparkline-chart 
                    [data]="pos.chartData || []" 
                    [inRange]="pos.inRange">
                 </app-sparkline-chart>
              </div>
            </div>

            <!-- Bottom Row: Liquidity & Actions -->
            <div class="flex flex-col xl:flex-row xl:items-center justify-between gap-6 bg-white/[0.02] border border-white/[0.05] rounded-[14px] p-4">
              <!-- TVL Block -->
              <div class="flex items-center gap-8 sm:pr-6 sm:border-r border-white/5">
                <div class="flex flex-col">
                  <span class="text-text-muted text-[12px] font-bold mb-1">{{pos.metric1Label}}</span>
                  <span class="text-white font-black text-[14px]">{{pos.metric1Value}}</span>
                </div>
                <div class="flex flex-col">
                  <span class="text-text-muted text-[12px] font-bold mb-1">{{pos.metric2Label}}</span>
                  <span class="text-white font-black text-[14px]">{{pos.metric2Value}}</span>
                </div>

                <!-- Price Range Block -->
                <div *ngIf="pos.minPrice !== '0.00' || pos.maxPrice !== '0.00' || pos.isFullRange" class="flex items-center gap-8 pl-8 sm:border-l border-white/5">
                  <ng-container *ngIf="!pos.isFullRange; else fullRangeTemplate">
                    <div class="flex flex-col">
                      <span class="text-text-muted text-[12px] font-bold mb-1">Min Price</span>
                      <span class="text-white font-black text-[14px]">{{pos.minPrice}} <span class="text-text-dim text-[11px] font-bold ml-0.5">{{pos.metric2Label}} per {{pos.metric1Label}}</span></span>
                    </div>
                    <div class="flex flex-col">
                      <span class="text-text-muted text-[12px] font-bold mb-1">Max Price</span>
                      <span class="text-white font-black text-[14px]">{{pos.maxPrice}} <span class="text-text-dim text-[11px] font-bold ml-0.5">{{pos.metric2Label}} per {{pos.metric1Label}}</span></span>
                    </div>
                  </ng-container>
                  <ng-template #fullRangeTemplate>
                    <div class="flex flex-col">
                      <span class="text-text-muted text-[12px] font-bold mb-1">Price Range</span>
                      <span class="text-emerald-400 font-black text-[14px]">Full Range</span>
                    </div>
                  </ng-template>
                </div>
              </div>

              <!-- Buttons -->
              <div class="flex items-center gap-2 w-full sm:w-auto">
                 <!-- Standard Liquidity Buttons -->
                <ng-container *ngIf="!pos.isStakedInFarm && !pos.isExternal">
                  <button (click)="openRemoveModal(pos)" class="flex-1 sm:flex-none bg-[#1a1a1a] border border-white/10 hover:bg-white/10 hover:border-white/30 text-white text-[13px] font-bold px-6 py-3 rounded-[12px] transition-all">Remove</button>
                  <button (click)="openClaimModal(pos)" class="flex-1 sm:flex-none bg-gold text-[#050505] border border-gold/30 hover:bg-gold/90 text-[13px] font-black px-6 py-3 rounded-[12px] transition-all shadow-[0_0_20px_rgba(245,183,59,0.2)] hover:shadow-[0_0_30px_rgba(245,183,59,0.4)]">Claim Fees</button>
                </ng-container>

                <!-- External Liquidity Buttons -->
                <ng-container *ngIf="!pos.isStakedInFarm && pos.isExternal">
                  <button (click)="openRemoveModal(pos)" class="flex-1 sm:flex-none bg-[#1a1a1a] border border-white/10 hover:bg-white/10 hover:border-white/30 text-white text-[13px] font-bold px-6 py-3 rounded-[12px] transition-all">Remove</button>
                  <button (click)="openClaimModal(pos)" class="flex-1 sm:flex-none bg-gold text-[#050505] border border-gold/30 hover:bg-gold/90 text-[13px] font-black px-6 py-3 rounded-[12px] transition-all shadow-[0_0_20px_rgba(245,183,59,0.2)] hover:shadow-[0_0_30px_rgba(245,183,59,0.4)]">Claim Fees</button>
                </ng-container>

                <!-- Staked Farming Buttons -->
                <ng-container *ngIf="pos.isStakedInFarm">
                  <button (click)="openUnstakeModal(pos)" class="flex-1 sm:flex-none bg-[#1a1a1a] border border-white/10 hover:bg-white/10 hover:border-white/30 text-white text-[13px] font-bold px-6 py-3 rounded-[12px] transition-all">Unstake</button>
                  <button (click)="openClaimRewardModal(pos)" class="flex-1 sm:flex-none bg-gold text-[#050505] border border-gold/30 hover:bg-gold/90 text-[13px] font-black px-6 py-3 rounded-[12px] transition-all shadow-[0_0_20px_rgba(245,183,59,0.2)] hover:shadow-[0_0_30px_rgba(245,183,59,0.4)]">Rewards</button>
                </ng-container>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <!-- Pagination Controls -->
      <div *ngIf="totalPositionsPages() > 1" class="flex items-center justify-between border-t border-white/5 pt-4">
        <div class="text-text-muted text-[12px] font-bold">
          Page {{positionsPage()}} of {{totalPositionsPages()}}
        </div>
        <div class="flex items-center gap-2">
          <button (click)="prevPositionsPage()" [disabled]="positionsPage() === 1" class="w-8 h-8 rounded-[8px] border border-white/10 flex items-center justify-center text-text-muted hover:text-white hover:border-white/30 disabled:opacity-30 disabled:cursor-not-allowed transition-colors bg-[#050505]">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
          </button>
          <button (click)="nextPositionsPage()" [disabled]="positionsPage() === totalPositionsPages()" class="w-8 h-8 rounded-[8px] border border-white/10 flex items-center justify-center text-text-muted hover:text-white hover:border-white/30 disabled:opacity-30 disabled:cursor-not-allowed transition-colors bg-[#050505]">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- NFTs Tab -->
  <div *ngIf="activeTab === 'NFTs'">
    <div class="flex items-center justify-between mb-5 px-1">
      <h3 class="text-white font-bold text-[18px]">LP NFTs</h3>
    </div>
    
    <!-- Loading State -->
    <div *ngIf="isLoadingPositions" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      <div *ngFor="let _ of [1,2,3]" class="bg-[#050505] border border-white/[0.08] rounded-[24px] h-[300px] animate-pulse"></div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoadingPositions && activePositions().length === 0" class="py-12 text-center border border-white/5 rounded-[16px] bg-[#050505]/50">
      <div class="w-16 h-16 bg-white/[0.02] border border-white/5 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg class="w-8 h-8 text-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
      <h4 class="text-white font-bold text-[16px] mb-2">No NFTs Found</h4>
      <p class="text-text-muted text-[13px] mb-6 max-w-sm mx-auto">You don't have any active LP NFTs.</p>
    </div>

    <!-- NFT Cards Grid -->
    <div *ngIf="!isLoadingPositions && activePositions().length > 0" class="flex flex-wrap items-center justify-center sm:justify-start gap-5">
      <div *ngFor="let pos of paginatedActivePositions()" class="relative group w-[180px] h-[270px] shrink-0 rounded-[12px] cursor-pointer overflow-hidden transition-transform duration-300 hover:-translate-y-1" style="background-color: #191B1F;">
        
        <!-- Main Card Container (Pure Flat) -->
        <div class="relative h-full w-full overflow-hidden flex flex-col justify-between p-3.5 border border-[#2C2F36] rounded-[12px]">
          
          <!-- Generative Curve SVG (No blur, no shadow) -->
          <div class="absolute inset-0 pointer-events-none overflow-hidden">
            <svg class="absolute inset-0 w-full h-full" viewBox="0 0 180 270" preserveAspectRatio="none">
              <path d="M-50,165 Q90,45 220,165" fill="none" stroke="url(#curve-grad)" stroke-width="2"/>
              <path d="M-50,195 Q90,75 220,195" fill="none" stroke="url(#curve-grad)" stroke-width="1" opacity="0.5"/>
              <defs>
                <linearGradient id="curve-grad" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" [attr.stop-color]="pos.color1 || '#ffffff'" stop-opacity="1" />
                  <stop offset="100%" [attr.stop-color]="pos.color2 || '#f5b73b'" stop-opacity="1" />
                </linearGradient>
              </defs>
            </svg>
            <!-- Solid Colored Orbs (Flat) -->
            <div class="absolute -top-10 -right-10 w-28 h-28 rounded-full opacity-20" [style.backgroundColor]="pos.color1 || '#ffffff'"></div>
            <div class="absolute -bottom-10 -left-10 w-28 h-28 rounded-full opacity-20" [style.backgroundColor]="pos.color2 || '#f5b73b'"></div>
          </div>

          <!-- Header: Protocol & ID (Flat) -->
          <div class="relative z-20 flex justify-between items-start w-full">
            <div class="text-white font-medium text-[8px] tracking-widest uppercase flex flex-col opacity-80">
              <span>DEX</span>
              <span>LP NFT</span>
            </div>
            <div class="bg-[#2C2F36] px-2 py-0.5 rounded text-white font-medium text-[8px] tracking-widest">
              #{{ pos.tokenId || pos._id?.substring(pos._id.length - 6) || '---' }}
            </div>
          </div>

          <!-- Center: Tokens & Title (Flat) -->
          <div class="relative z-20 flex flex-col items-center justify-center flex-1 py-2">
            <div class="flex -space-x-2.5 mb-3">
              <div class="w-10 h-10 rounded-full flex items-center justify-center text-[11px] font-bold text-white border-[2px] border-[#191B1F] overflow-hidden" [style.backgroundColor]="pos.color1">
                <img *ngIf="pos.image1" [src]="pos.image1" class="w-full h-full object-cover">
                <span *ngIf="!pos.image1">{{pos.icon1?.charAt(0)}}</span>
              </div>
              <div *ngIf="pos.icon2" class="w-10 h-10 rounded-full flex items-center justify-center text-[11px] font-bold text-white border-[2px] border-[#191B1F] overflow-hidden" [style.backgroundColor]="pos.color2">
                <img *ngIf="pos.image2" [src]="pos.image2" class="w-full h-full object-cover">
                <span *ngIf="!pos.image2">{{pos.icon2?.charAt(0)}}</span>
              </div>
            </div>
            <h3 class="text-white font-semibold text-[15px] tracking-tight text-center leading-none">{{pos.title}}</h3>
            <div class="text-white/80 font-medium text-[9px] mt-2 bg-[#2C2F36] px-2 py-0.5 rounded uppercase tracking-wider">
              Fee Tier: {{pos.feeTier || '0.3'}}%
            </div>
          </div>

          <!-- Footer: Details (Flat) -->
          <div class="relative z-20 bg-[#212429] rounded-[8px] p-3 mt-1">
            <div class="flex justify-between items-center mb-1.5 pb-1.5 border-b border-[#2C2F36]">
              <span class="text-white/50 text-[8px] font-semibold uppercase tracking-wider">Status</span>
              <span *ngIf="pos.inRange" class="text-[#27AE60] font-semibold text-[8px] flex items-center gap-1"><span class="w-1 h-1 rounded-full bg-[#27AE60]"></span>In Range</span>
              <span *ngIf="!pos.inRange" class="text-[#EB5757] font-semibold text-[8px] flex items-center gap-1"><span class="w-1 h-1 rounded-full bg-[#EB5757]"></span>Out of Range</span>
            </div>

          </div>
          
        </div>
      </div>
    </div>
    
    <!-- Pagination -->
    <div class="mt-6 flex items-center justify-between border-t border-white/5 pt-4" *ngIf="activePositions().length > positionsLimit">
      <div class="text-[12px] font-bold text-text-muted">
        Page <span class="text-white">{{positionsPage()}}</span> of <span class="text-white">{{totalActivePositionsPages()}}</span>
      </div>
      <div class="flex items-center gap-2">
        <button (click)="prevPositionsPage()" [disabled]="positionsPage() === 1" class="w-8 h-8 rounded-[8px] border border-white/10 flex items-center justify-center text-text-muted hover:text-white hover:border-white/30 disabled:opacity-30 disabled:cursor-not-allowed transition-colors bg-[#050505]">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
        </button>
        <button (click)="nextPositionsPage()" [disabled]="positionsPage() === totalActivePositionsPages()" class="w-8 h-8 rounded-[8px] border border-white/10 flex items-center justify-center text-text-muted hover:text-white hover:border-white/30 disabled:opacity-30 disabled:cursor-not-allowed transition-colors bg-[#050505]">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Activity Tab -->
  <div *ngIf="activeTab === 'Activity'">
    <app-history [isEmbedded]="true"></app-history>
  </div>
</section>

<!-- Not Connected State -->
<section *ngIf="!appState.isWalletConnected()" class="max-w-[1320px] mx-auto px-6 lg:px-10 pt-20 pb-20 relative z-10 animate-fade-in flex flex-col items-center justify-center min-h-[60vh]">
  <div class="bg-[#0c0c0c]/80 border border-white/5 rounded-[24px] p-10 max-w-md w-full text-center shadow-2xl backdrop-blur-xl group hover:border-white/10 transition-all duration-500 relative overflow-hidden">
    <!-- Decorative background glow -->
    <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gold/5 blur-[80px] rounded-full pointer-events-none group-hover:bg-gold/10 transition-all duration-500"></div>
    
    <div class="w-20 h-20 bg-white/[0.02] border border-white/10 rounded-full flex items-center justify-center mx-auto mb-6 relative z-10 group-hover:border-gold/30 group-hover:scale-105 transition-all duration-500">
      <svg class="w-10 h-10 text-gold/80" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
      </svg>
    </div>
    <h2 class="text-white font-display font-black text-[24px] mb-3 relative z-10">Your Portfolio Awaits</h2>
    <p class="text-text-muted text-[14px] mb-8 leading-relaxed relative z-10">Connect your wallet to track your assets, positions, and performance across the DEX ecosystem.</p>
    
    <button (click)="appState.openConnectModal()" class="w-full relative z-10 bg-gold hover:bg-gold/90 text-[#050505] font-black text-[15px] py-4 rounded-[12px] transition-all shadow-[0_0_20px_rgba(245,183,59,0.3)] hover:shadow-[0_0_30px_rgba(245,183,59,0.5)] flex items-center justify-center gap-2 group/btn">
      <svg class="w-5 h-5 group-hover/btn:scale-110 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
      </svg>
      Connect Wallet
    </button>
  </div>
</section>

<!-- Remove Liquidity Modal -->
<div *ngIf="isRemoveModalOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" (click)="closeRemoveModal()"></div>
  
  <!-- Modal Content -->
  <div class="bg-[#0c0c0c] border border-white/10 rounded-[20px] w-full max-w-[400px] relative z-10 shadow-2xl overflow-hidden animate-slide-up">
    <!-- Header -->
    <div class="px-6 py-5 border-b border-white/5 flex items-center justify-between">
      <h3 class="text-white font-bold text-[16px]">Remove Liquidity</h3>
      <button (click)="closeRemoveModal()" class="text-text-muted hover:text-white transition-colors">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
      </button>
    </div>

    <!-- Body -->
    <div class="p-6">
      <div class="flex items-center gap-3 mb-6">
        <div class="flex -space-x-2">
           <div class="w-8 h-8 rounded-full flex items-center justify-center text-[9px] font-black text-white border-2 border-[#0c0c0c] z-10 shadow-sm overflow-hidden" [style.backgroundColor]="selectedPosition?.color1">
              <img *ngIf="selectedPosition?.image1" [src]="selectedPosition?.image1" class="w-full h-full object-cover">
              <span *ngIf="!selectedPosition?.image1">{{selectedPosition?.icon1?.charAt(0)}}</span>
           </div>
           <div *ngIf="selectedPosition?.icon2" class="w-8 h-8 rounded-full flex items-center justify-center text-[9px] font-black text-white border-2 border-[#0c0c0c] shadow-sm overflow-hidden" [style.backgroundColor]="selectedPosition?.color2">
              <img *ngIf="selectedPosition?.image2" [src]="selectedPosition?.image2" class="w-full h-full object-cover">
              <span *ngIf="!selectedPosition?.image2">{{selectedPosition?.icon2?.charAt(0)}}</span>
           </div>
        </div>
        <div class="text-white font-black text-[15px]">{{selectedPosition?.title}}</div>
      </div>

      <!-- Percentage Slider Box -->
      <div class="bg-[#050505] border border-white/5 rounded-[12px] p-5 mb-6">
        <div class="text-center mb-6">
          <div class="text-gold font-display font-black text-[42px] leading-none">{{removePercentage}}%</div>
          <div class="text-text-muted text-[11px] font-bold mt-1">Amount to remove</div>
        </div>
        
        <!-- Slider Input -->
        <input type="range" min="1" max="100" [(ngModel)]="removePercentage" class="w-full h-1.5 bg-white/10 rounded-lg appearance-none cursor-pointer accent-gold mb-4">
        
        <!-- Quick Select Buttons -->
        <div class="grid grid-cols-4 gap-2">
          <button (click)="removePercentage = 25" class="py-1.5 rounded-[6px] text-[11px] font-bold transition-colors" [ngClass]="removePercentage === 25 ? 'bg-gold/10 text-gold border border-gold/30' : 'bg-white/5 text-text-muted border border-transparent hover:bg-white/10 hover:text-white'">25%</button>
          <button (click)="removePercentage = 50" class="py-1.5 rounded-[6px] text-[11px] font-bold transition-colors" [ngClass]="removePercentage === 50 ? 'bg-gold/10 text-gold border border-gold/30' : 'bg-white/5 text-text-muted border border-transparent hover:bg-white/10 hover:text-white'">50%</button>
          <button (click)="removePercentage = 75" class="py-1.5 rounded-[6px] text-[11px] font-bold transition-colors" [ngClass]="removePercentage === 75 ? 'bg-gold/10 text-gold border border-gold/30' : 'bg-white/5 text-text-muted border border-transparent hover:bg-white/10 hover:text-white'">75%</button>
          <button (click)="removePercentage = 100" class="py-1.5 rounded-[6px] text-[11px] font-bold transition-colors" [ngClass]="removePercentage === 100 ? 'bg-gold/10 text-gold border border-gold/30' : 'bg-white/5 text-text-muted border border-transparent hover:bg-white/10 hover:text-white'">Max</button>
        </div>
      </div>

      <!-- You Receive Breakdown -->
      <div class="mb-6">
        <div class="text-text-muted text-[11.5px] font-bold mb-3">You will receive:</div>
        <div class="flex flex-col gap-2">
          <div class="flex items-center justify-between bg-white/[0.02] border border-white/5 rounded-[8px] p-3">
            <div class="flex items-center gap-2">
              <div class="w-6 h-6 rounded-full flex items-center justify-center text-[7px] font-black text-white overflow-hidden" [style.backgroundColor]="selectedPosition?.color1">
                <img *ngIf="selectedPosition?.image1" [src]="selectedPosition?.image1" class="w-full h-full object-cover">
                <span *ngIf="!selectedPosition?.image1">{{selectedPosition?.icon1?.charAt(0)}}</span>
              </div>
              <span class="text-white font-bold text-[13px]">{{selectedPosition?.icon1}}</span>
            </div>
            <div class="text-right">
              <div *ngIf="!isLoadingLiveFees" class="text-white font-bold text-[14px]">{{receiveAmount0}}</div>
              <div *ngIf="isLoadingLiveFees" class="w-16 h-4 bg-white/10 rounded animate-pulse inline-block mt-1"></div>
            </div>
          </div>
          <div *ngIf="selectedPosition?.icon2" class="flex items-center justify-between bg-white/[0.02] border border-white/5 rounded-[8px] p-3">
            <div class="flex items-center gap-2">
              <div class="w-6 h-6 rounded-full flex items-center justify-center text-[7px] font-black text-white overflow-hidden" [style.backgroundColor]="selectedPosition?.color2">
                <img *ngIf="selectedPosition?.image2" [src]="selectedPosition?.image2" class="w-full h-full object-cover">
                <span *ngIf="!selectedPosition?.image2">{{selectedPosition?.icon2?.charAt(0)}}</span>
              </div>
              <span class="text-white font-bold text-[13px]">{{selectedPosition?.icon2}}</span>
            </div>
            <div class="text-right">
              <div *ngIf="!isLoadingLiveFees" class="text-white font-bold text-[14px]">{{receiveAmount1}}</div>
              <div *ngIf="isLoadingLiveFees" class="w-16 h-4 bg-white/10 rounded animate-pulse inline-block mt-1"></div>
            </div>
          </div>
        </div>
      </div>

      <button (click)="confirmRemoveLiquidity()" [disabled]="isRemovingLiquidity" class="w-full bg-gold hover:bg-gold/90 text-[#050505] font-black text-[14px] py-3.5 rounded-[12px] transition-all shadow-[0_0_20px_rgba(245,183,59,0.2)] disabled:opacity-50 disabled:cursor-not-allowed">
        <span *ngIf="!isRemovingLiquidity">Remove {{removePercentage}}%</span>
        <span *ngIf="isRemovingLiquidity" class="flex items-center justify-center gap-2">
          <svg class="animate-spin h-4 w-4 text-[#050505]" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
          Removing...
        </span>
      </button>
    </div>
  </div>
</div>

<!-- Claim Fees Modal -->
<div *ngIf="isClaimModalOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" (click)="closeClaimModal()"></div>
  
  <!-- Modal Content -->
  <div class="bg-[#0c0c0c] border border-white/10 rounded-[20px] w-full max-w-[400px] relative z-10 shadow-2xl overflow-hidden animate-slide-up">
    <!-- Header -->
    <div class="px-6 py-5 border-b border-white/5 flex items-center justify-between">
      <h3 class="text-white font-bold text-[16px]">Claim Uncollected Fees</h3>
      <button (click)="closeClaimModal()" class="text-text-muted hover:text-white transition-colors">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
      </button>
    </div>

    <!-- Body -->
    <div class="p-6">
      
      <div class="bg-[#050505] border border-gold/20 rounded-[12px] p-6 mb-6 text-center relative overflow-hidden">
        <div class="absolute inset-0 bg-gradient-to-b from-gold/5 to-transparent"></div>
        <div class="relative z-10">
          <div class="text-white font-bold text-[13px] text-center mb-1">Total Fees Earned</div>
          <div class="text-gold font-black text-[22px] text-center drop-shadow-[0_0_15px_rgba(245,183,59,0.3)]">
            <ng-container *ngIf="isLoadingLiveFees">
              <div class="flex items-center justify-center pt-1 pb-1">
                <svg class="animate-spin h-6 w-6 text-gold" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
              </div>
            </ng-container>
            <ng-container *ngIf="!isLoadingLiveFees">
              <span>{{liveFeeAmount0}} {{selectedPosition?.icon1 || ''}}</span>
              <br/>
              <span *ngIf="selectedPosition?.icon2">+ {{liveFeeAmount1}} {{selectedPosition?.icon2}}</span>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="mb-6">
        <div class="text-white font-bold text-[13px] mb-3 border-b border-white/5 pb-2">Fee Breakdown</div>
        <div class="flex flex-col gap-3">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <div class="w-5 h-5 rounded-full flex items-center justify-center text-[6px] font-black text-white overflow-hidden" [style.backgroundColor]="selectedPosition?.color1">
                <img *ngIf="selectedPosition?.image1" [src]="selectedPosition?.image1" class="w-full h-full object-cover">
                <span *ngIf="!selectedPosition?.image1">{{selectedPosition?.icon1?.charAt(0)}}</span>
              </div>
              <span class="text-white font-bold text-[12.5px]">{{selectedPosition?.icon1}}</span>
            </div>
            <div class="text-right">
              <div *ngIf="isLoadingLiveFees" class="flex items-center justify-end">
                <svg class="animate-spin h-3.5 w-3.5 text-gold" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
              </div>
              <div *ngIf="!isLoadingLiveFees" class="text-white font-black text-[12.5px]">{{liveFeeAmount0}}</div>
              <div class="text-text-muted text-[10px] font-bold">
                <span *ngIf="isLoadingLiveFees">~$--</span>
                <span *ngIf="!isLoadingLiveFees">~${{ liveFeeUsdFormatted0 }}</span>
              </div>
            </div>
          </div>
          <div *ngIf="selectedPosition?.icon2" class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <div class="w-5 h-5 rounded-full flex items-center justify-center text-[6px] font-black text-white overflow-hidden" [style.backgroundColor]="selectedPosition?.color2">
                <img *ngIf="selectedPosition?.image2" [src]="selectedPosition?.image2" class="w-full h-full object-cover">
                <span *ngIf="!selectedPosition?.image2">{{selectedPosition?.icon2?.charAt(0)}}</span>
              </div>
              <span class="text-white font-bold text-[12.5px]">{{selectedPosition?.icon2}}</span>
            </div>
            <div class="text-right">
              <div *ngIf="isLoadingLiveFees" class="flex items-center justify-end">
                <svg class="animate-spin h-3.5 w-3.5 text-gold" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
              </div>
              <div *ngIf="!isLoadingLiveFees" class="text-white font-black text-[12.5px]">{{liveFeeAmount1}}</div>
              <div class="text-text-muted text-[10px] font-bold">
                <span *ngIf="isLoadingLiveFees">~$--</span>
                <span *ngIf="!isLoadingLiveFees">~${{ liveFeeUsdFormatted1 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button (click)="confirmClaimFees()" [disabled]="isClaimingFees || hasNoFees || isLoadingLiveFees" class="w-full bg-gold hover:bg-gold/90 text-[#050505] font-black text-[14px] py-3.5 rounded-[12px] transition-all shadow-[0_0_20px_rgba(245,183,59,0.2)] disabled:opacity-50 disabled:cursor-not-allowed">
        <span *ngIf="!isClaimingFees">{{ hasNoFees ? 'No Fees to Collect' : 'Collect Fees' }}</span>
        <span *ngIf="isClaimingFees" class="flex items-center justify-center gap-2">
          <svg class="animate-spin h-4 w-4 text-[#050505]" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
          Collecting...
        </span>
      </button>
    </div>
  </div>
</div>

<!-- Unstake Modal -->
<div *ngIf="isUnstakeModalOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4">
  <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" (click)="closeUnstakeModal()"></div>
  
  <div class="bg-[#0c0c0c] border border-gold/20 rounded-[20px] w-full max-w-[400px] relative z-10 shadow-[0_0_50px_rgba(245,183,59,0.1)] overflow-hidden animate-slide-up">
    <!-- Header -->
    <div class="px-6 py-5 border-b border-white/5 flex items-center justify-between">
      <h3 class="text-white font-bold text-[16px]">Unstake LP NFT</h3>
      <button (click)="closeUnstakeModal()" class="text-text-muted hover:text-white transition-colors">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
      </button>
    </div>

    <!-- Body -->
    <div class="p-6">
      <div class="flex items-center gap-3 mb-6">
        <div class="flex -space-x-2">
          <div class="w-8 h-8 rounded-full flex items-center justify-center text-[9px] font-black text-white border-2 border-[#0c0c0c] z-10 shadow-sm overflow-hidden" [style.backgroundColor]="selectedPosition?.color1">
             <img *ngIf="selectedPosition?.image1" [src]="selectedPosition?.image1" class="w-full h-full object-cover">
             <span *ngIf="!selectedPosition?.image1">{{selectedPosition?.icon1?.charAt(0)}}</span>
          </div>
          <div *ngIf="selectedPosition?.icon2" class="w-8 h-8 rounded-full flex items-center justify-center text-[9px] font-black text-white border-2 border-[#0c0c0c] shadow-sm overflow-hidden" [style.backgroundColor]="selectedPosition?.color2">
             <img *ngIf="selectedPosition?.image2" [src]="selectedPosition?.image2" class="w-full h-full object-cover">
             <span *ngIf="!selectedPosition?.image2">{{selectedPosition?.icon2?.charAt(0)}}</span>
          </div>
        </div>
        <div>
          <div class="text-white font-black text-[15px]">{{selectedPosition?.title}}</div>
          <div class="text-text-muted text-[11px] font-bold">Staked in Farming Pool</div>
        </div>
      </div>
      
      <p class="text-text-muted text-[13px] mb-6">
        Unstaking this NFT will remove it from the farming pool. Any pending rewards will be automatically harvested to your wallet.
      </p>

      <button (click)="confirmUnstake()" [disabled]="isUnstaking || isLoadingPid" class="w-full block relative z-20 bg-[#0c0c0c] border border-gold/30 hover:bg-gold/10 hover:border-gold/50 text-white font-bold text-[14px] py-3.5 rounded-[12px] transition-all disabled:opacity-50 disabled:cursor-not-allowed">
        <span *ngIf="!isUnstaking && !isLoadingPid">Confirm Unstake</span>
        <span *ngIf="isLoadingPid && !isUnstaking" class="flex items-center justify-center gap-2">
          <svg class="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
          Finding Position...
        </span>
        <span *ngIf="isUnstaking" class="flex items-center justify-center gap-2">
          <svg class="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
          Unstaking...
        </span>
      </button>
    </div>
  </div>
</div>

<!-- Claim Reward Modal -->
<div *ngIf="isClaimRewardModalOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4">
  <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" (click)="closeClaimRewardModal()"></div>
  
  <div class="bg-[#0c0c0c] border border-gold/20 rounded-[20px] w-full max-w-[400px] relative z-10 shadow-[0_0_50px_rgba(245,183,59,0.1)] overflow-hidden animate-slide-up">
    <!-- Header -->
    <div class="px-6 py-5 border-b border-white/5 flex items-center justify-between">
      <h3 class="text-white font-bold text-[16px]">Claim Farming Rewards</h3>
      <button (click)="closeClaimRewardModal()" class="text-text-muted hover:text-white transition-colors">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
      </button>
    </div>

    <!-- Body -->
    <div class="p-6">
      <div class="flex items-center gap-3 mb-6">
        <div class="flex -space-x-2">
          <div class="w-8 h-8 rounded-full flex items-center justify-center text-[9px] font-black text-white border-2 border-[#0c0c0c] z-10 shadow-sm overflow-hidden" [style.backgroundColor]="selectedPosition?.color1">
             <img *ngIf="selectedPosition?.image1" [src]="selectedPosition?.image1" class="w-full h-full object-cover">
             <span *ngIf="!selectedPosition?.image1">{{selectedPosition?.icon1?.charAt(0)}}</span>
          </div>
          <div *ngIf="selectedPosition?.icon2" class="w-8 h-8 rounded-full flex items-center justify-center text-[9px] font-black text-white border-2 border-[#0c0c0c] shadow-sm overflow-hidden" [style.backgroundColor]="selectedPosition?.color2">
             <img *ngIf="selectedPosition?.image2" [src]="selectedPosition?.image2" class="w-full h-full object-cover">
             <span *ngIf="!selectedPosition?.image2">{{selectedPosition?.icon2?.charAt(0)}}</span>
          </div>
        </div>
        <div>
          <div class="text-white font-black text-[15px]">{{selectedPosition?.title}}</div>
          <div class="text-text-muted text-[11px] font-bold">Staked in Farming Pool</div>
        </div>
      </div>
      
      <div class="bg-[#050505] border border-gold/30 rounded-[12px] p-6 mb-6 text-center relative overflow-hidden">
        <div class="absolute inset-0 bg-gradient-to-b from-gold/10 to-transparent"></div>
        <div class="relative z-10">
          <div class="text-white font-bold text-[13px] text-center mb-1">Pending DEX Rewards</div>
          <div *ngIf="isLoadingLiveReward" class="flex justify-center my-2">
            <svg class="animate-spin h-6 w-6 text-gold" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
          </div>
          <div *ngIf="!isLoadingLiveReward" class="text-gold font-black text-[32px] text-center drop-shadow-[0_0_15px_rgba(245,183,59,0.5)]">{{liveRewardAmount}}</div>
        </div>
      </div>

      <button (click)="confirmClaimReward()" [disabled]="isClaimingReward || hasNoRewards" class="w-full bg-gold hover:bg-gold/90 text-[#050505] font-black text-[14px] py-3.5 rounded-[12px] transition-all shadow-[0_0_20px_rgba(245,183,59,0.2)] disabled:opacity-50 disabled:cursor-not-allowed">
        <span *ngIf="!isClaimingReward">Claim Rewards</span>
        <span *ngIf="isClaimingReward" class="flex items-center justify-center gap-2">
          <svg class="animate-spin h-4 w-4 text-[#050505]" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
          Claiming...
        </span>
      </button>
    </div>
  </div>
</div>
